import { call, takeLatest } from 'redux-saga/effects';

import * as constants from './support.constants';
import * as services from './support.saga-services';
import * as types from './support.types';

function* invokeSubmitSupportRequest(action: types.ISubmitSupportRequest) {
  yield call(services.submitSupportRequest, action.payload);
}

export function* watchSupportSaga() {
  yield takeLatest(constants.SUBMIT_SUPPORT_REQUEST, invokeSubmitSupportRequest);
}
